import { MaxOrderQuantityForm, MaxOrderQuantity } from './';

export const maxOrderQuantityRoutes = [
  {
    path: 'max-orderable-qty',
    protected: true,
    element: MaxOrderQuantity,
    roles: [
      'MAX_ORDERABLE_QTY_VIEW',
      'MAX_ORDERABLE_QTY_EDIT',
    ],
  },
  {
    path: 'max-orderable-qty/add-new',
    protected: true,
    element: MaxOrderQuantityForm,
    roles: [
      'MAX_ORDERABLE_QTY_VIEW',
      'MAX_ORDERABLE_QTY_EDIT',
    ],
  },
];
